// list from https://reactnative.dev/docs/image#source

export const isSupportedImageFormat = (filename: string) => {
    return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp'].includes(parseFileExtension(filename.toLowerCase()));
};

export const isPdfFormat = (filename: string) => {
    return parseFileExtension(filename.toLowerCase()) === 'pdf';
};

export const parseFileExtension = (filename: string) => {
    return filename.slice(filename.lastIndexOf('.') + 1);
};

export type ReactNativeFileOptions = {
    uri: string;
    name: string;
    type?: string;
};
export class ReactNativeFile {
    name: string;
    uri: string;
    type?: string;

    constructor(options: ReactNativeFileOptions) {
        const { uri, name, type } = options;

        this.uri = uri;
        this.name = name;
        this.type = type;
    }
}

export const isReactNativeFile = (value: unknown): value is ReactNativeFile => {
    return value instanceof ReactNativeFile;
};
